import type { ReactNode } from 'react';

export const symbol_hexagon: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M307-120q-16 0-29.79-7.88Q263.43-135.75 255-150L81-450q-8-14.33-8-30.16Q73-496 81-510l174-300q8.43-14.25 22.21-22.13Q291-840 307-840h346q16 0 29.79 7.87Q696.57-824.25 705-810l174 300q8 14.33 8 30.16 0 15.84-8 29.84L705-150q-8.43 14.25-22.21 22.12Q669-120 653-120H307Zm-1-60h348l172-300-172-300H306L133-480l173 300Zm174-300Z"
		/>
	</svg>
);
